import { Component, OnInit, AfterViewInit,Input, SimpleChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../core/auth/auth.service';
import { UserService } from './../../../core/user.service';
import * as Chart from "chart.js";
import { bloomAdd } from '@angular/core/src/render3/di';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cqm-ns-monitoring',
  templateUrl: './cqm-ns-monitoring.component.html',
  styleUrls: ['./cqm-ns-monitoring.component.css']
})
export class CqmNsMonitoringComponent implements OnInit {

 azureProfile: any;
  hostUrl: any;
  projectId: any;
  azureStatus: any;
  value: any;
  isoDate: any;
  NowDate: any;
  fromTime: any;
  toTime: any;
  userId: any;
  constructor(   private http: HttpClient,
    private route: ActivatedRoute,
    private userService: UserService, private authService: AuthService,) { }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl = this.userService.getUrl();
    //this.projectId = this.route.snapshot.params["projectId"];
    this.userId = localStorage.getItem("userid");

    this.projectId = localStorage.getItem("projectId");
    var s = new Date();
    this.NowDate = new Date(s).toISOString().split('.')[0]+"Z";
    s.setMinutes(s.getMinutes() - 5);
    this.isoDate = new Date(s).toISOString().split('.')[0]+"Z";
      this.fromTime = this.NowDate;
      this.toTime = this.isoDate;
    // this.http
    // .get(
    //   encodeURI(
    //     this.hostUrl + "/api/issue/azureProfileDetailsServer/" + this.projectId  
    //   )
    // )
    // .subscribe(data => {
    //   this.azureProfile =data;
    //   console.log(data)

    // });
    
      this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/statusdetails/" + this.projectId  + '/' + this.isoDate + '/'+this.NowDate
        )
      )
      .subscribe(data => {
        this.azureStatus =data;
        console.log(this.azureStatus,'hdjhahjjkahckjahkchachjs')
        this.value = this.azureStatus[0].id;

      });
  }
  onChangeAzure(value){
    //   this.application.forEach(obj=>{
    //     if(obj['View_id'] == 'value'){
    //      this.youGotIDValue = value
    //      this.youGotName = obj['Name']
    //     }
    //  })
     console.log('value parent',value)
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-monitoring/cqm-ns-monitoring.component.ts